import React from "react";
import { getValue } from "@utils/lodash";

function DashboardSvgComponent(props: any) {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        width={
          getValue(props, `size`, "") ? getValue(props, `size`, "") : "24px"
        }
        viewBox="0 0 24 24"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_18181"
              data-name="Rectangle 18181"
              width="24"
              height="24"
              transform="translate(-16221 -8271)"
              fill="#fff"
            />
          </clipPath>
        </defs>
        <g
          id="Mask_Group_289"
          data-name="Mask Group 289"
          transform="translate(16221 8271)"
          clipPath="url(#clip-path)"
        >
          <path
            id="dashboard_FILL0_wght300_GRAD0_opsz24"
            d="M15.265-23.118v-5.824h7.676v5.824ZM4.941-19.412v-9.529h7.676v9.529H4.941Zm10.324,8.471v-9.529h7.676v9.529Zm-10.324,0v-5.824h7.676v5.824H4.941ZM6.529-21h4.5v-6.353h-4.5Zm10.324,8.471h4.5v-6.353h-4.5Zm0-12.176h4.5v-2.647h-4.5ZM6.529-12.529h4.5v-2.647h-4.5ZM11.029-21ZM16.853-24.706ZM16.853-18.882ZM11.029-15.177Z"
            transform="translate(-16222.941 -8239.059)"
            fill={
              getValue(props, `color`, "")
                ? getValue(props, `color`, "")
                : "#5f6368"
            }
          />
        </g>
      </svg>
    </div>
  );
}

export default DashboardSvgComponent;
